import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { DuplicateEmailModal } from '@zr/jobseeker-public/components/DuplicateEmailModal';

import screenTypeTelemetry from '../Screens/ScreenTypes/screenTypeTelemetry';
import { EXISTING_EMAIL_ADDRESS_MODAL } from '../screenTypeSchema';

import {
  STRING_CTA_START,
  STRING_CTA_LINK_NAME,
  STRING_CLOSE,
} from '../../labels';

const defaultStrings = {
  STRING_CTA_START,
  STRING_CTA_LINK_NAME,
  STRING_CLOSE,
};

export function ExistingEmailAddressModal({
  applyData,
  setOpenExistingEmailModal,
  onCloseModal,
  screenTypeObject,
}) {
  useEffect(() => {
    // Log the JobSeeker being presented with the existing email address modal
    const { logView } = screenTypeTelemetry(EXISTING_EMAIL_ADDRESS_MODAL, applyData);
    logView();

    return null;
  }, [applyData]);


  const handleCloseModal = () => {
    // Log the interaction
    const { logInteraction } = screenTypeTelemetry(EXISTING_EMAIL_ADDRESS_MODAL, applyData);
    logInteraction('close');

    // Close this existing email address modal
    setOpenExistingEmailModal(false);

    // call the onDone function of the job
    applyData?.onDone(screenTypeObject.application_state, screenTypeObject.enc_contact_id);

    // Close the entire apply flow modal
    onCloseModal();
  };


  return (
    <DuplicateEmailModal onCloseModal={handleCloseModal} strings={defaultStrings} />
  );
}

ExistingEmailAddressModal.propTypes = {
  applyData: PropTypes.object.isRequired,
  setOpenExistingEmailModal: PropTypes.func,
  onCloseModal: PropTypes.func.isRequired,
  screenTypeObject: PropTypes.object.isRequired,
};

ExistingEmailAddressModal.defaultProps = {
  setOpenExistingEmailModal: () => {},
};

export default ExistingEmailAddressModal;
